import { apiRequest } from "./client";
import type { TreeSharingDto, UserSummaryDto } from "./types";

/** People-picker autocomplete: matches email and username prefixes, and name fragments (3+ characters). */
export const searchUsers = (query: string, token: string): Promise<UserSummaryDto[]> =>
	apiRequest<UserSummaryDto[]>(`/accounts/search?query=${encodeURIComponent(query)}`, { token });

/** Collaborators and pending invitations for a tree. Requires Admin on the tree. */
export const getTreeSharing = (treeId: string, token: string): Promise<TreeSharingDto> =>
	apiRequest<TreeSharingDto>(`/trees/${treeId}/sharing`, { token });

/** Shares the tree with a registered user, found by email or username. Rejected when no account matches. */
export const inviteToTree = (treeId: string, emailOrUsername: string, role: string, token: string): Promise<void> =>
	apiRequest<void>(`/trees/${treeId}/members`, { method: "POST", body: { treeId, emailOrUsername, role }, token });

export const changeTreeMemberRole = (treeId: string, userId: string, role: string, token: string): Promise<void> =>
	apiRequest<void>(`/trees/${treeId}/members/${userId}`, {
		method: "PATCH",
		body: { treeId, userId, role },
		token
	});

export const removeTreeMember = (treeId: string, userId: string, token: string): Promise<void> =>
	apiRequest<void>(`/trees/${treeId}/members/${userId}`, { method: "DELETE", token });

export const revokeTreeInvitation = (treeId: string, invitationId: string, token: string): Promise<void> =>
	apiRequest<void>(`/trees/${treeId}/invitations/${invitationId}`, { method: "DELETE", token });

/** Accepts a pending share: the tree becomes visible under "Shared with Me". */
export const acceptTreeShare = (treeId: string, token: string): Promise<void> =>
	apiRequest<void>(`/trees/${treeId}/share/accept`, { method: "POST", token });

/** Rejects a pending share: the tree disappears from "Shared with Me". */
export const declineTreeShare = (treeId: string, token: string): Promise<void> =>
	apiRequest<void>(`/trees/${treeId}/share/decline`, { method: "POST", token });
